module.exports = __webpack_public_path__ + "assets/img/settings.b4dcf670.svg";